import React from "react";
import { Container, Row, Col, Button } from "shards-react";
import HTMLInvoice from '../utils/invoice';
import { withRouter } from 'react-router-dom';
import { fetchGet } from "../utils/api";

class AcceptanceForm extends React.Component {
    state = {
        data: {},
        settings: {},
        showClose: false,
        currentState: {},
        scroll: null,
        returnTo: null
    }

    constructor(props) {
        super(props);
        this.printRef = React.createRef();
    }

    onPrint = () => {
        const content = this.printRef.current.innerHTML;
        const printWindow = window.open('', '', 'width=2000,height=1000');
        printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
        <style>
        @media print {
        body {
            margin: 0;
            padding: 0;
        }

        .one-page {
            page-break-before: avoid;
            page-break-after: avoid;
            page-break-inside: avoid;
        }

        /* Force it to fit */
        html, body {
            width: 100%;
            height: 110%;
            overflow: hidden;
        }

        /* Optional: scale down if content is too big */
        .one-page {
            transform: scale(0.95); /* adjust as needed */
            transform-origin: top left;
        }
        }
        </style>
        </head>
        <body>${content}</body>
      </html>
    `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };




    componentDidMount() {
        this.fetchInvoice()
        this.fetchSettings()
        if (this.props.location.state) {
            this.setState({
                data: this.props.location.state.row || {},
                currentState: this.props.location.state.currentState || null,
                scroll: this.props.location.state.scroll || null,
                returnTo: this.props.location.state.returnTo || null
            })
        }
    }

    static getDerivedStateFromProps(props) {
        if (!props.location.state) {
            props.history.push('/user-forms')
        }
        return {
            data: props.location.state.row || {},
            currentState: props.location.state.currentState || null,
            scroll: props.location.state.scroll || null,
            returnTo: props.location.state.returnTo || null
        }
    }


    fetchInvoice() {
        const invoice = HTMLInvoice(this.state.data, this.state.settings)
        return invoice
    }

    fetchSettings() {
        var api = '/utils/settings'

        fetchGet(api,
            (response) => {
                this.setState({ settings: response })
            },
            (response) => {
                this.setState({ message: response.message, error: true })
            }
        )
    }

    render() {
        const { currentState, scroll } = this.state

        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4 px-4">
                    <Col md='10'><h6 className='m-0'>Declaration Form</h6></Col>
                    <Col md='2'>

                        <div className="button-row">
                            <button className="btn secondary" onClick={this.onPrint}>Print</button>
                            <button className="btn outline" onClick={() => {
                                if (this.state.returnTo) {
                                    this.props.history.push(this.state.returnTo, {
                                        currentState: currentState,
                                        scroll: scroll
                                    })
                                } else {
                                    this.props.history.goBack()
                                }
                            }}
                            >Done</button>
                        </div>
                        {/* <Button theme='secondary' type='button' style={{ float: 'right' }}
                            onClick={() => {
                                if (this.state.returnTo) {
                                    this.props.history.push(this.state.returnTo, {
                                        currentState: currentState,
                                        scroll: scroll
                                    })
                                } else {
                                    this.props.history.goBack()
                                }
                            }}

                        > Go Back
                        </Button> */}
                    </Col>
                    {/* <Button theme='success' type='button' style={{ float: 'right' }}
                        onClick={this.onPrint}
                    >Print
                    </Button> */}

                </Row>
                <Row>
                    <Col lg="12">
                        <div ref={this.printRef} dangerouslySetInnerHTML={{ __html: this.fetchInvoice() }} />
                    </Col>

                </Row>
            </Container>
        )
    }
}

export default withRouter(AcceptanceForm)
